<template>
  <div class="w-100">
    <ul>
      <li v-for="child in children" :key="child">
        <slot :name="child">
          <div>{{child}}</div>
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "cmsMenuList",
  props: { children: Array }
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0.9rem;
  margin: 0;
  border-top: 1px solid $white-one-color;
  &:last-child {
    border-bottom: 1px solid $white-one-color;
  }
}

li {
  display: flex;
  padding-right: 0.4rem;

  min-height: 3.2rem;
  &:nth-child(1):not(:last-child) {
    border-bottom: 1px solid $white-one-color;
  }

  &:not(:nth-child(1)):not(:nth-child(2)) {
    border-top: 1px solid $white-one-color;
  }
}
</style>